<div [formGroup]="formData" *ngIf="formReady" class="searchFormContainer comparablesSearchContainer comparablesPropertiesSearchContainer">
  <div class="searchFormContainerLeft">
    <table aria-hidden="true">
      <tbody>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.puid' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="puid" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'property.buildingName' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="buildingName" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.city' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="municipalManual" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.postalCode' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="postalCodeManual" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.street' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="street" />
          </td>
        </tr>

        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'property.propertyType' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="propertyType" />
          </td>
        </tr>

        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'property.propertySubType' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="propertySubType" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.yearOfConstruction' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <div class="dual-input-field-container">
              <div class="comparablesSearchFromToInput">
                <input type="number" min="1" formControlName="yearOfConstructionFrom" />
              </div>
              <div class="comparablesSearchFromToInput">
                <input type="number" min="1" formControlName="yearOfConstructionTo" />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.totalLettableArea' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <div class="dual-input-field-container">
              <div class="comparablesSearchFromToInput">
                <input type="number" min="1" formControlName="totalLettableAreaFrom" />
              </div>
              <div class="comparablesSearchFromToInput">
                <input type="number" min="1" formControlName="totalLettableAreaTo" />
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'comparablesProperty.energyLabel' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <kendo-dropdownlist formControlName="energyPerformanceLabelId" style="width: 100%"
                                [data]="reflistData.ref_lease_transaction_building_energy"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true">
            </kendo-dropdownlist>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
